<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row>
        <el-form>
          <el-col :span="6">
            <el-form-item label="会员手机号：" label-width="100px">
              <el-input
                placeholder="请输入手机号"
                clearable
                v-model="phone"
                class="header-search-input ml10"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="部门：" label-width="100px">
              <el-select
                v-model="departmentCode"
                placeholder="请选择部门"
                clearable
              >
                <el-option
                  v-for="item in departmentOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="等级：" label-width="100px">
              <el-select v-model="levelCode" placeholder="请选择等级" clearable>
                <el-option
                  v-for="item in memberLevelOptions"
                  :key="item.id"
                  :label="item.levelName"
                  :value="item.levelCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="门店：" label-width="100px">
              <el-select
                v-model="merchantCode"
                placeholder="请选择门店"
                clearable
              >
                <el-option
                  v-for="item in merchantListOptions"
                  :key="item.merchantCode"
                  :label="item.merchantName"
                  :value="item.merchantCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="消费方式：" label-width="100px">
              <el-select
                v-model="consumeSourceCode"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in consumeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="消费时间：" label-width="100px">
              <el-date-picker
                v-model="dateRange"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button type="primary" @click="search()">搜索</el-button>
            <el-button type="primary">导出</el-button>
            <el-button type="primary"
              >储值汇总：{{ amount.toFixed(2) }}</el-button
            >
          </el-col>
        </el-form>
      </el-row>

      <!-- <div class="block">
          <div class="search-btn">
            <el-button type="primary" @click="search()">搜索</el-button>
          </div>
          <el-button type="primary">导出</el-button>
          <el-button type="primary">储值汇总：{{ amount }}</el-button>
        </div> -->
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style="margin-top: 20px">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              @sort-change="sortChange"
            >
              <!-- <el-table-column label="序号" align="center" prop="序号">
                <template slot-scope="scope">
                  <span>{{ scope.row.id }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="序号"
                align="center"
                prop="序号"
                type="index"
              >
              </el-table-column>
              <el-table-column label="消费时间" align="center" prop="消费时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.consumeDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="消费门店名称"
                align="center"
                prop="消费门店名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.consumeMerchantName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="用户名" align="center" prop="用户名">
                <template slot-scope="scope">
                  <span>{{ scope.row.userName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="手机号" align="center" prop="手机号">
                <template slot-scope="scope">
                  <span>{{ scope.row.phone }}</span>
                </template>
              </el-table-column>
              <el-table-column label="消费金额" align="center" prop="消费金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.amount }}</span>
                </template>
              </el-table-column>
              <el-table-column label="剩余金额" align="center" prop="剩余金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.remaining }}</span>
                </template>
              </el-table-column>
              <el-table-column label="卡类型" align="center" prop="卡类型名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.cardTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="会员等级"
                align="center"
                prop="会员等级名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.levelName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="订单号" align="center" prop="订单号">
                <template slot-scope="scope">
                  <span>{{ scope.row.orderNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column label="会员卡号" align="center" prop="会员卡号">
                <template slot-scope="scope">
                  <span>{{ scope.row.memberCardID }}</span>
                </template>
              </el-table-column>
              <el-table-column label="补贴金额" align="center" prop="补贴金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.subsidyAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="剩余补贴金额"
                align="center"
                prop="剩余补贴金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remainSubsidyAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column label="流水号" align="center" prop="流水号">
                <template slot-scope="scope">
                  <span>{{ scope.row.transNo }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作员名称"
                align="center"
                prop="操作员名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.operUserName }}</span>
                </template>
              </el-table-column>

              <!-- <el-table-column label="商家编码" align="center"  prop="商家编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商家名称" align="center"  prop="商家名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="用户编码" align="center"  prop="用户编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.userCode }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="openid" align="center"  prop="openid" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.openId }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="赠送金额" align="center"  prop="赠送金额" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.present }}</span>
                        </template>
                    </el-table-column>


                    <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.consumeTypeCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.consumeTypeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="消费类型:" align="center"  prop="消费类型:" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.consumeSourceCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="消费类型:" align="center"  prop="消费类型:" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.consumeSourceName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否日结" align="center"  prop="是否日结" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.isDaily }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" align="center"  prop="备注" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.remark }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="消费门店" align="center"  prop="消费门店" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.consumeMerchantCode }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="连锁编码" align="center"  prop="连锁编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.groupCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="连锁名称" align="center"  prop="连锁名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.groupName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="部门编码" align="center"  prop="部门编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.departmentCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="部门名称" align="center"  prop="部门名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.departmentName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="会员等级编码" align="center"  prop="会员等级编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.levelCode }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="卡类型编码" align="center"  prop="卡类型编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.cardTypeCode }}</span>
                        </template>
                    </el-table-column>


                    <el-table-column label="操作人编码" align="center"  prop="操作人编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.operUserCode }}</span>
                        </template>
                    </el-table-column>


                    <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.clientCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.clientName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.mealCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.mealName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="期初次数" align="center"  prop="期初次数" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.startTimes }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="使用次数" align="center"  prop="使用次数" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.useTimes }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="剩余次数" align="center"  prop="剩余次数" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.remainingTimes }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="剩余多少天" align="center"  prop="剩余多少天" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.remainingDays }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">
                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="编辑"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-edit textblue f16"
                      @click="gotoDetail(scope.row.id, scope.row.userCode)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-delete textblue f16 ml20"
                      @click="del(scope.row.id)"
                    ></i>
                  </el-tooltip> -->

                  <el-button
                    style="padding:0;"
                    type="text"
                    size="mini"
                    @click="openDialogDetail(scope.row.id)"
                    >详情</el-button
                  >
                  <el-button
                    style="padding:0;"
                    type="text"
                    size="mini"
                    @click="exportOrderInfoXls(scope.row.orderNumber)"
                    >导出</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-row></el-scrollbar
        >
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
    <el-dialog title="订单信息" :visible.sync="dialogDetails" width="1000px">
      <div>
        <el-table
          :data="detailsData"
          style="width: 100%;"
          border
          fit
          :height="height"
          highlight-current-row
          @sort-change="sortChange"
        >
          <el-table-column label="订单号" align="center" prop="orderNumber">
            <template slot-scope="scope">
              <span>{{ scope.row.orderNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品类别" align="center" prop="categoryName">
            <template slot-scope="scope">
              <span>{{ scope.row.categoryName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.productName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单价" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.productPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column label="购买数量" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.num }}</span>
            </template>
          </el-table-column>
          <el-table-column label="退货数量" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.returnNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="点单时间" align="center" prop="orderTime">
            <template slot-scope="scope">
              <span>{{ scope.row.orderTime | dataFormat }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer ">
        <el-button @click="dialogDetails = false">取消</el-button>
        <el-button @click="dialogDetails = false" type="primary"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 256, //表格高度
      value: "",
      dateRange: [],
      phone: "",
      amount: 0.0,
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: ""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      memberLevelOptions: [],
      departmentOptions: [],
      merchantListOptions: [],
      consumeOptions: [
        {
          value: "online",
          label: "线上消费"
        },
        {
          value: "offline",
          label: "线下消费"
        }
      ],
      options: [],
      levelCode: "",
      departmentCode: "",
      merchantCode: "",
      consumeSourceCode: "",
      dialogDetails: false,
      detailsData: []
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getMemberLevelList();
    this.getDepartmentList();
    this.getMerchantList();
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition.id = this.searchInput;
      this.queryInfo.condition.phone = this.phone;
      this.queryInfo.condition.departmentCode = this.departmentCode;
      this.queryInfo.condition.levelCode = this.levelCode;
      this.queryInfo.condition.storeCode = this.merchantCode;
      this.queryInfo.condition.consumeSourceCode = this.consumeSourceCode;
      if (this.dateRange != null && this.dateRange.length > 0) {
        this.queryInfo.condition.startDate = this.dateRange[0];
        this.queryInfo.condition.endDate = this.dateRange[1];
      } else {
        this.queryInfo.condition.startDate = null;
        this.queryInfo.condition.endDate = null;
      }

      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantMemberConsumeRecords/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize
        }
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantMemberConsumeRecords/delete", { id: id })
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    //查询用户等级
    getMemberLevelList() {
      var that = this;

      let merchantCode = localStorage.getItem("merchantCode");
      that.$http
        .post("/select/queryMemberLevelList", { merchantCode })
        .then(function(response) {
          console.log("等级" + response.data.data);
          if (response.data.code == 200) {
            that.memberLevelOptions = response.data.data;
          }
        });
    },
    //查询商家列表
    getMerchantList() {
      var that = this;
      let merchantCode = localStorage.getItem("merchantCode");
      that.$http
        .post("/select/queryMerchantList", { merchantCode })
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.merchantListOptions = response.data.data;
          }
        });
    },
    //查询部门列表
    getDepartmentList() {
      var that = this;
      let merchantCode = localStorage.getItem("merchantCode");
      that.$http
        .post("/select/queryDepartmentList", { merchantCode })
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.departmentOptions = response.data.data;
          }
        });
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.merchantCode = localStorage.getItem(
        "merchantCode"
      );
      that.$http
        .post("/merchantMemberConsumeRecord/list", that.queryInfo)
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.pager.count;
            that.queryInfo.currPage = response.data.data.pager.currPage;
            that.tableData = response.data.data.pager.data;
            that.amount = response.data.data.amount;
          }
        });

      // that.$http
      //   .post("/merchantMemberConsumeRecord/queryAmount", that.queryInfo)
      //   .then(function(response) {
      //     console.log("储值统计：" + response.data.data);
      //     if (response.data.code == 200) {
      //       that.amount = response.data.data;
      //     }
      //   });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    openDialogDetail(id) {
      this.dialogDetails = true;
      this.id = id;
      this.getDetailsData();
    },
    getDetailsData() {
      var that = this;
      let data = {};
      data.id = that.id;
      that.$http
        .post(
          "merchantMemberConsumeRecord/queryMerchantMemberConsumeRecordsDetails",
          data
        )
        .then(response => {
          console.log("明细", response.data);
          if (response.data.code == 200) {
            that.detailsData = response.data.data.itemList;
          }
        });
    },
    exportOrderInfoXls(orderNumber) {
      var that = this;
      let data = {};
      data.orderNumber = orderNumber;
      that.$http
        .post("/merchantMemberConsumeRecord/exportOrderInfoXls", data)
        .then(response => {
          if (response.data.code == 200) {
               var a = document.createElement("a");
            a.href = response.data.data;
            a.download = response.data.data;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            a.remove();
            that.$message.success("导出成功");
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
// .select-box span{
//      width: 170px;
//  }
.block {
  display: flex;
  // width: 300px;
}
.search-btn {
  display: flex;
  margin-left: 10px;
  margin-bottom: 20px;
}
.select-box {
  display: flex;
  // width: 200px;
  margin-bottom: 20px;
}
.search-inpute-name {
  display: flex;
}
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
/deep/ .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 100% !important;
}
</style>
